import { IsEnum, IsNotEmpty, IsString } from "class-validator";

export enum IdentificationDocumentTypeEnumDto {
    Dni = "dni",
    Nie = "nie",
    Passport = "passport",
    Nif = "nif",
}

export class IdentificationDocumentTypeDto {
    @IsEnum(IdentificationDocumentTypeEnumDto)
    @IsNotEmpty()
    key!: IdentificationDocumentTypeEnumDto;

    @IsString()
    @IsNotEmpty()
    value!: string;
}
